import { useSearch } from 'hooks/react.hooks'
import { useIntegrations } from 'contexts/IntegrationsContext'
import { Types } from './constants'
import { LoginSence, LogoutSence, LogoutSenceSuccess } from './components'

export const Sence = () => {
  const {
    sence: { params, authenticated, loading, isSence, data },
  } = useIntegrations()
  const [{ type }, setSearch] = useSearch<'type'>()

  if (!isSence || !data) return null

  if (type === Types.logout_success)
    return (
      <LogoutSenceSuccess
        onHide={() => {
          setSearch({ type: '' })
        }}
      />
    )
  if (
    (type === Types.logout_error && authenticated) ||
    type === Types.login_success
  )
    return <LogoutSence data={data} loading={loading} params={params} />

  return <LoginSence />
}
